import Vicente2 from '../Vicente/Vicente (1).webp'
import Vicente3 from '../Vicente/Vicente (1).webp'
import Vicente4 from '../Vicente/Vicente (1).webp'
import Vicente5 from '../Vicente/Vicente (1).webp'
import Vicente6 from '../Vicente/Vicente (1).webp'
import Vicente7 from '../Vicente/Vicente (1).webp'
import Vicente8 from '../Vicente/Vicente (1).webp'
import Vicente9 from '../Vicente/Vicente (1).webp'
import Vicente10 from '../Vicente/Vicente (1).webp'
import Vicente11 from '../Vicente/Vicente (1).webp'
import Vicente12 from '../Vicente/Vicente (1).webp'
import Vicente13 from '../Vicente/Vicente (1).webp'


const Vicenteimages =[
    Vicente2,Vicente3,Vicente4,Vicente5,Vicente6,Vicente7,Vicente8,Vicente9,Vicente10,Vicente11,Vicente12,Vicente13
]

export default Vicenteimages;